<form [formGroup]="identifiersForm">

  <sc-sub-title>zugeordnete Identitäten</sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <table class="common-style">
    <tr>
      <th>
        <sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.entity.active"></sc-dictionary-label>
      </th>
      <th>
        <sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.entity.identifier"></sc-dictionary-label>
      </th>
      <th></th>
    </tr>
    <tr *ngFor="let identifier of identifiers">
      <td class="centered-column">
        <div (click)="changeActive(identifier)">
          <i *ngIf="!identifier.active" class="fa-regular fa-square pointer"></i>
          <i *ngIf="identifier.active" class="fa-regular fa-square-check pointer"></i>
        </div>
      </td>
      <td>
        {{identifier.identifier}}
      </td>
      <td>
        <div (click)="this.delete(identifier)">
          <sc-icon iconClass="fa-trash pointer"></sc-icon>
        </div>
      </td>
    </tr>
    <tr *ngIf="identifiers == null || identifiers.length === 0">
      <td colspan="3" class="centered-column">
        <sc-dictionary-label dictionaryKey="tmc-yard.common.message.no-data"></sc-dictionary-label>
      </td>
    </tr>
  </table>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title>Identität hinzufügen</sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-string-field formControlName="newIdentifier" labelDictionaryKey="tmc-yard.supplementaryequipment.ui.identifier"></sc-string-field>
    <sc-content-spacer vertical></sc-content-spacer>
    <button mat-icon-button type="button" [disabled]="!addNewEnabled()" (click)="this.addNewIdentifier()">
      <i class="fa-light
      fa-plus"></i>
    </button>
  </sc-flex>

</form>
